import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

export default function MemorizationItemExtraFields({ formData, setFormData }) {
  return (
    <>
      <Grid size={12}>
        <FormControl fullWidth variant="standard">
          <InputLabel>Memorization Type</InputLabel>
          <Select
            value={
              formData.item_metadata?.memorization_type !== undefined
                ? formData.item_metadata?.memorization_type
                : ""
            }
            label="Memorization Type"
            required
            onChange={(event) =>
              setFormData((formData) => {
                formData.item_metadata.memorization_type = event.target.value;
                return { ...formData };
              })
            }
          >
            <MenuItem value={"current_week"}>Current Week</MenuItem>
            <MenuItem value={"previous_week"}>Previous Week</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </>
  );
}
